// extracted by mini-css-extract-plugin
module.exports = {"cardv5":"AWKsK","topRow":"gdp2X","brand_logo":"pf6vF","noLogo":"OI0Ut"};